/** A Meta ads goal's steps, from the goal to Launch at the bottom of Ads (notes/AUDIENCE.md 4). */
export const META_STEPS = ["Goal", "Channel", "Playbook", "Plan", "Audience", "Ads"] as const;
